import { render, staticRenderFns } from "./TestEmailModal.vue?vue&type=template&id=634a7f28&scoped=true"
import script from "./TestEmailModal.vue?vue&type=script&lang=js"
export * from "./TestEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a7f28",
  null
  
)

export default component.exports